var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class HistoryDownload {
    static downloadHistory(rootElement, chatStart, interactionID, apiURL, fontURL) {
        return __awaiter(this, void 0, void 0, function* () {
            let filename = this.getFilename();
            const payload = yield this.createChatHistoryHTML(filename, rootElement, chatStart, interactionID, fontURL);
            const response = yield fetch(apiURL + "/generate", {
                method: "POST",
                credentials: 'include',
                body: JSON.stringify({ payload: payload }),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (response.ok) {
                const downloadId = yield response.json().then((data) => {
                    if (data.downloadId) {
                        return data.downloadId;
                    }
                    return "";
                }).catch((error) => {
                    return "";
                });
                if (downloadId) {
                    this.save(filename, apiURL + "/download/" + downloadId + "?filename=" + filename);
                }
            }
        });
    }
    static getFilename() {
        let filename_prefix = "a1chat";
        let date = new Date();
        let stringDate = "";
        try {
            stringDate = "-" + date.toLocaleDateString("de-DE");
        }
        catch (e) {
        }
        return filename_prefix + stringDate + ".html";
    }
    static save(filename, url) {
        const elem = window.document.createElement('a');
        elem.href = url;
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
    static checkForIOsAlternativeBrowsers() {
        let userAgent = window.navigator.userAgent;
        if (userAgent.match(/crios/i)) {
            return true;
        }
        return false;
    }
    static getBase64ImageDataURLClass(img) {
        return new Promise((resolve, rejects) => {
            try {
                let hash = "imgclass-" + this.hash(img.src);
                if (this.imageDataURL[hash]) {
                    resolve(hash);
                    return;
                }
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                var imageObj = new Image();
                imageObj.onload = () => {
                    ctx.drawImage(imageObj, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, canvas.width, canvas.height);
                    var dataURL = canvas.toDataURL("image/png");
                    this.imageDataURL[hash] = dataURL;
                    resolve(hash);
                };
                imageObj.onerror = () => {
                    rejects();
                };
                imageObj.crossOrigin = 'anonymous'; //not necessary, if image hosted on same server
                imageObj.src = img.src;
                //return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
            }
            catch (e) {
                rejects();
            }
        });
    }
    static createChatHistoryHTML(title, rootElement, chatStart, interactionID, fontURL) {
        return __awaiter(this, void 0, void 0, function* () {
            let rootClonedNode = null;
            let stack = new Array();
            stack.push([rootElement, rootClonedNode]);
            while (stack.length > 0) {
                let top = stack.shift();
                let parent = top[1];
                if (top[0] instanceof HTMLElement) {
                    let element = top[0];
                    if (!this.IGNORED_CLASSES.some(r => element.classList.contains(r)) && !this.IGNORED_ELEMENT_IDS.some(r => element.id == r)) {
                        let clonedNode = element.cloneNode(false);
                        const computedStyle = window.getComputedStyle(element);
                        const cssClass = this.createClassFromStyle(computedStyle);
                        clonedNode.className = "";
                        clonedNode.classList.add(cssClass);
                        if (element.tagName == 'IMG') {
                            try {
                                let imageDataURLClass = yield this.getBase64ImageDataURLClass(element);
                                clonedNode.classList.add(imageDataURLClass);
                            }
                            catch (e) {
                            }
                        }
                        else if (element.tagName == 'BUTTON') {
                            this.addButtonLink(clonedNode);
                        }
                        element.childNodes.forEach((child) => { stack.push([child, clonedNode]); });
                        if (parent != null) {
                            parent.appendChild(clonedNode);
                        }
                        else {
                            clonedNode.classList.add("contentStyle");
                            rootClonedNode = clonedNode;
                        }
                    }
                }
                else if (top[0] instanceof Text) {
                    let text = top[0];
                    let clonedNode = text.cloneNode(false);
                    parent.appendChild(clonedNode);
                }
            }
            let mainDiv = document.createElement("DIV");
            mainDiv.classList.add("mainDivStyle");
            if (!rootClonedNode.style.width || rootClonedNode.style.width == "auto") {
                if (document.getElementById(this.CHAT_WIDGET_MAIN_DIV_ID)) {
                    rootClonedNode.style.width = window.getComputedStyle(document.getElementById(this.CHAT_WIDGET_MAIN_DIV_ID)).width;
                }
                else {
                    rootClonedNode.style.width = "540px";
                }
            }
            mainDiv.appendChild(this.createChatHeader(chatStart, interactionID));
            mainDiv.appendChild(rootClonedNode);
            return this.createHTMLDocument(title, this.createHeaderWithStyleNode(fontURL), mainDiv).outerHTML;
        });
    }
    static createChatHeader(chatStart, interactionID) {
        if (!interactionID) {
            interactionID = "Unbekannt";
        }
        let header = document.createElement("DIV");
        header.style.display = "flex";
        header.style.height = "70px";
        header.style.width = "auto";
        header.style.borderTop = "1pt solid rgb(215, 215, 215)";
        header.style.borderRight = "1pt solid rgb(215, 215, 215)";
        header.style.borderLeft = "1pt solid rgb(215, 215, 215)";
        let chatName = document.createElement("DIV");
        chatName.style.fontFamily = "A1Sans-Regular, A1Sans, Arial, Helvetica, sans-serif";
        chatName.style.margin = "auto";
        chatName.style.fontSize = "25px";
        chatName.innerHTML = "A1 Chat";
        let chatHeaderInfo = document.createElement("DIV");
        chatHeaderInfo.style.margin = "auto";
        chatHeaderInfo.style.color = "rgb(128, 128, 128)";
        chatHeaderInfo.style.fontSize = "14px";
        let chatHeaderInfoChatStart = document.createElement("DIV");
        chatHeaderInfoChatStart.style.padding = "0 0 5px 0";
        chatHeaderInfoChatStart.style.fontFamily = "A1Sans-Regular, A1Sans, Arial, Helvetica, sans-serif";
        let stringTimestamp = "";
        try {
            stringTimestamp = chatStart.toLocaleString('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: "numeric",
                minute: "numeric"
            });
        }
        catch (e) {
            stringTimestamp = chatStart.toLocaleString();
        }
        chatHeaderInfoChatStart.innerHTML = "Chatbeginn: " + stringTimestamp + " Uhr";
        let chatHeaderInfoInteractionId = document.createElement("DIV");
        chatHeaderInfoInteractionId.style.padding = "5px 0 0 0";
        chatHeaderInfoInteractionId.style.fontFamily = "A1Sans-Regular, A1Sans, Arial, Helvetica, sans-serif";
        chatHeaderInfoInteractionId.innerHTML = "Chat-ID: " + interactionID;
        chatHeaderInfo.appendChild(chatHeaderInfoChatStart);
        chatHeaderInfo.appendChild(chatHeaderInfoInteractionId);
        header.appendChild(chatName);
        header.appendChild(chatHeaderInfo);
        return header;
    }
    static createHTMLDocument(title, head, bodyElements) {
        let html = document.createElement("html");
        html.appendChild(head);
        let body = document.createElement("body");
        body.appendChild(bodyElements);
        html.appendChild(body);
        return html;
    }
    static createClassFromStyle(cssStyle) {
        let cssText = "";
        Array.from(cssStyle).forEach(key => cssText += key + ": " + cssStyle.getPropertyValue(key) + " " + cssStyle.getPropertyPriority(key) + ";");
        let hash = this.hash(cssText);
        hash = "class-" + hash;
        this.cssClasses[hash] = cssText;
        return hash;
    }
    static createHeaderWithStyleNode(fontURL) {
        let head = document.createElement('head');
        let meta = document.createElement("meta");
        meta.name = "viewport";
        meta.setAttribute("charset", "utf-8");
        meta.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no";
        head.appendChild(meta);
        if (fontURL) {
            let fontStyle = document.createElement('style');
            fontStyle.type = 'text/css';
            fontStyle.appendChild(document.createTextNode(" @font-face { font-family: 'A1Sans-Regular', 'A1Sans'; src: url(" + fontURL + "); }"));
            head.appendChild(fontStyle);
        }
        for (let clazz in this.cssClasses) {
            let style = document.createElement('style');
            style.type = 'text/css';
            style.appendChild(document.createTextNode(" ." + clazz + "{ " + this.cssClasses[clazz] + " }"));
            head.appendChild(style);
        }
        for (let clazz in this.imageDataURL) {
            let style = document.createElement('style');
            style.type = 'text/css';
            style.appendChild(document.createTextNode(" ." + clazz + "{ content: url(" + this.imageDataURL[clazz] + "); }"));
            head.appendChild(style);
        }
        let style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(" body { display: flex; margin: 0 }"));
        head.appendChild(style);
        let contentStyle = document.createElement('style');
        contentStyle.type = 'text/css';
        contentStyle.appendChild(document.createTextNode(" .contentStyle { display: block; border: 1pt solid rgb(215, 215, 215); height: auto } @media screen and (max-width: 767px) { .contentStyle { height: calc(100% - 70px) !important; max-height: 100% !important; } }"));
        head.appendChild(contentStyle);
        let mainDivStyle = document.createElement('style');
        mainDivStyle.type = 'text/css';
        mainDivStyle.appendChild(document.createTextNode(".mainDivStyle { margin: 25px auto auto; } @media screen and (max-width: 767px) { .mainDivStyle { margin:0; } } "));
        head.appendChild(mainDivStyle);
        return head;
    }
    static addButtonLink(element) {
        let url = element.getAttribute("data-url");
        if (url) {
            element.setAttribute("onclick", "window.open('" + url + "', '_blank');");
        }
    }
    static hash(data) {
        var hash = 0, i, chr;
        if (data.length === 0)
            return hash.toString();
        for (i = 0; i < data.length; i++) {
            chr = data.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash.toString();
    }
}
HistoryDownload.CHAT_WIDGET_MAIN_DIV_ID = "chatbotWindow";
HistoryDownload.IGNORED_CLASSES = [];
HistoryDownload.IGNORED_ELEMENT_IDS = ["chatWindow_content_overlay", "chatWindow_content_tag"];
HistoryDownload.cssClasses = {};
HistoryDownload.imageDataURL = {};
